<template>
  <UiOptionModal ref="modal" />
</template>

<script lang="ts" setup>
import type { UiOptionModal } from '#components'
import type { SVG_NAMES } from '~/components/icons'

interface Options {
  message?: LangString
  messageVars?: string[]
  title?: LangString
  titleVars?: string[]
}

const modal = ref<InstanceType<typeof UiOptionModal>>()
const _message: Ref<LangString> = ref()
const _messageVars: Ref<string[]> = ref()
const _title: Ref<LangString> = ref()
const _titleVars: Ref<string[]> = ref()
const openAwait = async (options?: Options) => {
  setOptionsValue(_title, 'title', props, options)
  setOptionsValue(_titleVars, 'titleVars', props, options)
  setOptionsValue(_message, 'message', props, options)
  setOptionsValue(_messageVars, 'messageVars', props, options)
  return await modal.value.openAwait({
    title: _title.value,
    titleVars: _titleVars.value,
    message: _message.value,
    messageVars: _messageVars.value,
    options: [
      {
        label: {
          ja: 'いいえ',
          en: 'No'
        },
      },
      {
        label: {
          ja: 'はい',
          en: 'Yes'
        },
        option: 1
      },
    ]
  })
}
defineExpose({ openAwait })

interface Props {
  title?: LangString
  titleVars?: string[]
  message?: LangString
  messageVars?: string[]
  icon?: SVG_NAMES
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
</style>
